/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelcitylabel2Inputs */

const en_channelcitylabel2 = /** @type {(inputs: Channelcitylabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City filter (optional)`)
};

const de_channelcitylabel2 = /** @type {(inputs: Channelcitylabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stadt-Filter (optional)`)
};

/**
* | output |
* | --- |
* | "City filter (optional)" |
*
* @param {Channelcitylabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelcitylabel2 = /** @type {((inputs?: Channelcitylabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelcitylabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelcitylabel2(inputs)
	return de_channelcitylabel2(inputs)
});
export { channelcitylabel2 as "channelCityLabel" }